<script setup>
import {computed} from 'vue'

import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const isDisabled = computed(() => {
    const sections = pageEditorStore.pageSections || []
    const index = sections.map(o => o.id).indexOf(pageEditorStore.activeSectionId)

    return index === sections.length - 1 || pageEditorStore.moveInProgress
})

const moveDown = () => {
    pageEditorStore.moveSectionDown()
}
</script>

<template>
    <Button @click="moveDown" :disabled="isDisabled" class="btn-sm d-flex align-items-center gap-2">
        <i class="bi bi-chevron-down"></i>
        Move down
    </Button>
</template>